import { render, staticRenderFns } from "./WechatPaymentPopup.vue?vue&type=template&id=8389b12c&scoped=true"
import script from "./WechatPaymentPopup.vue?vue&type=script&lang=js"
export * from "./WechatPaymentPopup.vue?vue&type=script&lang=js"
import style0 from "./WechatPaymentPopup.vue?vue&type=style&index=0&id=8389b12c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8389b12c",
  null
  
)

export default component.exports